<template>
  <DetailsLoader v-if="!path.hasApiData" />

  <dl
    v-if="path.hasApiData"
    class="border border-gray-200 p-4 md:pt-5 md:px-6 md:pb-6 rounded-lg flex flex-col gap-4 text-gray-800"
  >
    <DetailRow
      v-if="path.language"
      icon="globe"
      label="Language:"
    >
      <span v-text="path.language" />
    </DetailRow>
    <DetailRow
      v-if="path.visibleTo.length"
      icon="computer-mouse"
      label="One-Click Assign:"
    >
      <span
        v-for="item in path.visibleTo"
        :key="item"
        class="block after:content-[','] last:after:content-none"
      >
        {{ item }}
      </span>
    </DetailRow>
    <DetailRow 
      v-if="path.difficultyLevel"
      icon="dial"
      label="Ability:"
    >
      <span v-text="path.difficultyLevel" />
    </DetailRow>
  </dl>
</template>

<script lang="ts">
export default { name: 'PathSummary' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { useExternalContent } from '~/composables/useExternalContent'

import DetailRow from '~/components/externalContent/DetailRow.vue'
import DetailsLoader from '~/components/loaders/DetailsLoader.vue'

const props = defineProps<{
  pathEnc: string,
}>()

const {
  algoliaRecord,
  apiRecord,
  hasApiData,
} = useExternalContent(props.pathEnc)

// merge all the data for use in the template
const path = computed(() => {
  return {
    ...algoliaRecord,
    ...apiRecord.value,
    hasApiData,
  }
})
</script>
